import React, { useState } from 'react';
import SaveAsTemplate from "shared/components/SaveAsTemplate";

const PublishMyTemplate = ({ save_as_template_url, classes = null }) => {
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);

  return (
    <>
      <a
        className={classes || "btn btn-success btn-block"}
        onClick={() => setOpen(true)}
      >
        {i18n.t('save_as_template.save')}
      </a>
      {open &&
        <SaveAsTemplate
          onClose={onClose}
          caption={i18n.t('save_as_template.caption2')}
          save_as_template_url={save_as_template_url}
        />
      }
    </>
  );
};

export default PublishMyTemplate;
